import script from "./Customers.vue?vue&type=script&setup=true&lang=js"
export * from "./Customers.vue?vue&type=script&setup=true&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=63a2f5e5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a2f5e5"]])

export default __exports__